export const getUserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const LAST_CONTACT_FILTER_LABEL = "Exclude companies";

export const LAST_CONTACT_FILTER_INFO = "Filters out companies from your list that your team has already reached out to within a specific timeframe, preventing accidental double-contacting.";

export const LAST_CONTACT_FILTER_OPTIONS = [
  { value: "", label: "None" },
  { value: "today", label: "Contacted: Today" },
  { value: "7_days", label: "Contacted: 7 days ago" },
  { value: "14_days", label: "Contacted: 14 days ago" },
  { value: "30_days", label: "Contacted: 30 days ago" },
  { value: "60_days", label: "Contacted: 60 days ago" },
  { value: "90_days", label: "Contacted: 90 days ago" },
];

/** Map legacy month option values to day-based values. */
export const normalizeLastContactFilter = (value) => {
  const legacy = {
    "1_month": "30_days",
    "3_months": "60_days",
    "6_months": "90_days",
  };
  if (!value) return "";
  return legacy[value] || value;
};
